import { useEffect, useState } from "react";

interface Props {
  onPress: (digit: number) => void;
  disabled: boolean;
  dangerDigits: Set<number>;
  flashDigit?: { digit: number; tone: "safe" | "bust" } | null;
}

const LAYOUT: (number | "*" | "#")[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, "*", 0, "#"];

export function Keypad({ onPress, disabled, dangerDigits, flashDigit }: Props) {
  const [pressed, setPressed] = useState<number | null>(null);

  useEffect(() => {
    if (flashDigit) {
      setPressed(flashDigit.digit);
      const t = setTimeout(() => setPressed(null), 400);
      return () => clearTimeout(t);
    }
  }, [flashDigit]);

  return (
    <div className="keypad">
      {LAYOUT.map((key) => {
        if (typeof key !== "number") {
          return (
            <button key={key} disabled className="keypad-btn symbol" tabIndex={-1}>
              {key}
            </button>
          );
        }
        const isDanger = dangerDigits.has(key);
        const flashClass =
          pressed === key && flashDigit?.tone === "safe" ? "safe-flash" : "";
        return (
          <button
            key={key}
            disabled={disabled || isDanger}
            onClick={() => onPress(key)}
            className={`keypad-btn ${isDanger ? "danger" : ""} ${flashClass}`}
          >
            {key}
          </button>
        );
      })}
    </div>
  );
}
